function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_69150",
  "data-name": "Group 69150",
  transform: "translate(-390 -290)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_170",
  "data-name": "Ellipse 170",
  transform: "translate(390 290)",
  fill: "#12a10d",
  stroke: "#12a10d",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 24.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Icon_material-done",
  "data-name": "Icon material-done",
  d: "M13.5,24.3,7.2,18,5.1,20.1l8.4,8.4,18-18L29.4,8.4Z",
  transform: "translate(396.7 297.55)",
  fill: "#fff"
}));

var SvgSucces = function SvgSucces(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSucces, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/succes.47e7e194.svg";
export { ForwardRef as ReactComponent };